import reducers from './reducers';

export const NAME = 'reportGeo';
export default reducers;
